import Marquee from "react-fast-marquee";

const items = ["Confidence", "Safety", "Skills for Life", "Trust", "Water Safety", "Boca Raton"];

export const TaglineMarquee = ({ dark = false }) => (
  <div
    className="py-8 border-y overflow-hidden"
    style={{
      backgroundColor: dark ? "var(--navy)" : "transparent",
      borderColor: "rgba(212,175,55,0.3)",
    }}
    data-testid="tagline-marquee"
  >
    <Marquee speed={30} gradient={false} autoFill>
      {items.map((t, i) => (
        <div key={i} className="flex items-center">
          <span
            className="font-display italic px-8 text-4xl md:text-5xl"
            style={{ color: dark ? "var(--cream)" : "var(--navy)" }}
          >
            {t}
          </span>
          <span className="text-2xl" style={{ color: "var(--gold)" }}>✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
